import type { Meta, StoryFn } from '@storybook/react';
import { action } from '@storybook/addon-actions';

import { UtilitiesLayout, type UtilitiesLayoutProps } from '@pega/cosmos-react-work';
import { Flex } from '@pega/cosmos-react-core';

import useGenAIcoach from '../GenAICoach/useGenAICoach';

export default {
  title: 'Work/UtilitiesLayout',
  component: UtilitiesLayout
} as Meta;

export interface UtilitiesLayoutDemoProps extends UtilitiesLayoutProps {
  enableGenAICoach?: boolean;
  defaultExpandUtilities?: boolean;
  showGenAICoachErrorMessage?: boolean;
}

export const UtilitiesLayoutDemo: StoryFn<UtilitiesLayoutDemoProps> = (
  args: UtilitiesLayoutDemoProps
) => {
  const genAICoachProps = useGenAIcoach({
    enableGenAICoach: args.enableGenAICoach,
    showGenAICoachErrorMessage: args.showGenAICoachErrorMessage
  });

  return (
    <Flex container={{ justify: 'end' }}>
      {genAICoachProps && (
        <UtilitiesLayout
          genAICoachProps={genAICoachProps}
          defaultExpandUtilities={args.defaultExpandUtilities}
          onToggleUtilities={utilitiesExpanded =>
            action(`Utilities ${utilitiesExpanded ? 'expanded' : 'collapsed'}`)()
          }
        />
      )}
    </Flex>
  );
};

UtilitiesLayoutDemo.args = {
  enableGenAICoach: true,
  defaultExpandUtilities: true
};

UtilitiesLayoutDemo.argTypes = {
  enableGenAICoach: { control: { type: 'boolean' } },
  defaultExpandUtilities: { control: { type: 'boolean' } }
};
